import organization_post_list from './post-list';
import organization_post_add from './post-add';
import organization_post_edit from './post-edit';
import organization_post_detail from './post-detail';

export default {
    organization_post_list,
    organization_post_add,
    organization_post_edit,
    organization_post_detail,
};
